import { connect } from 'react-redux';

import {
  requestNetDepositLimit
} from '@xanadu/ui-shared/modules/depositLimits/actions';

import {
  displayModal,
} from '@xanadu/ui-shared/modules/modal/actions';

import DepositWithdrawalCheck from '@xanadu/ui-shared/components/DepositWithdrawalCheck';

const mapDispatchToProps = {
  requestNetDepositLimit,
  displayModal,
};

function mapStateToProps(state) {
  return {
    netDepositError: state.getIn(['depositLimits', 'error']),
    netDepositLimit: state.getIn(['depositLimits', 'netMonthlyDeposit']),
    loadingNetDeposit: state.getIn(['depositLimits', 'loadingNetDeposit']),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DepositWithdrawalCheck);
